import Option from '../interfaces/Option';


export interface ITypeUnitRepository {
    getTypes(): Promise<Option[]>;
    getSubTypes(valueType: string): Promise<Option[]>;
}


interface TypeUnit {
    label: string, value: string, subitems: SubTypeUnit[]
}

interface SubTypeUnit {
    label: string, value: string,
}

export class TypeUnitRepository implements ITypeUnitRepository {
    collection: TypeUnit[] = [
        {
            label: 'Hufiec', value: 'hufiec', subitems: [
                { label: 'przyboczny', value: 'przyboczny' },
                { label: 'drużynowy', value: 'drużynowy' },
                { label: 'członek kapituły HO', value: 'członek kapituły HO' },
                { label: 'przewodniczący kapituły HO', value: 'przewodniczący kapituły HO' },
                { label: 'członek kapituły HR', value: 'członek kapituły HR' },
                { label: 'przewodniczący kapituły HR', value: 'przewodniczący kapituły HR' },
                { label: 'członek komendy hufca', value: 'członek komendy hufca' },
                { label: 'zastępca hufcowego', value: 'zastępca hufcowego' },
                { label: 'hufcowy', value: 'hufcowy' },
                { label: 'inna funkcja', value: 'inne' },
            ]
        },
        {
            label: 'Chorągiew', value: 'chorągiew', subitems: [
                { label: 'członek komisji instruktorskiej', value: 'członek komisji instruktorskiej' },
                { label: 'przewodniczący komisji instruktorskiej', value: 'przewodniczący komisji instruktorskiej' },
                { label: 'członek szkoły instruktorskiej', value: 'członek szkoły instruktorskiej' },
                { label: 'komendant szkoły instruktorskiej', value: 'komendant szkoły instruktorskiej' },
                { label: 'członek kapituły HR', value: 'członek kapituły HR' },
                { label: 'przewodniczący kapituły HR', value: 'przewodniczący kapituły HR' },
                { label: 'prowadzący Krąg Harcerstwa Starszego', value: 'prowadzący KHS' },
                { label: 'referent', value: 'referent' },
                { label: 'członek komendy chorągwi', value: 'członek komendy chorągwi' },
                { label: 'zastępca komendanta chorągwi', value: 'zastępca komendanta chorągwi' },
                { label: 'komendant chorągwi', value: 'komendant chorągwi' },
                { label: 'inna funkcja', value: 'inne' },
            ]
        },
        {
            label: 'Okręg', value: 'okręg', subitems: [
                { label: 'członek zarządu okręgu', value: 'członek zarządu okręgu' },
                { label: 'członek komisji rewizyjnej okręgu', value: 'członek KRO' },
                { label: 'członek zarządu obwodu', value: 'członek zarządu obwodu' },
                { label: 'przewodniczący zarządu okręgu', value: 'przewodniczący zarządu obwodu' },
                { label: 'szczepowy', value: 'szczepowy' },
                { label: 'przewodniczący komisji rewizyjnej okręgu', value: 'przewodniczący KRO' },
                { label: 'przewodniczący zarządu okręgu', value: 'przewodniczący zarządu okręgu' },
                { label: 'inna funkcja', value: 'inne' },
            ]
        },
        {
            label: 'GKHy/GKHek', value: 'główna kwatera', subitems: [
                { label: 'członek GKH', value: 'członek GKH' },
                { label: 'członek komisji HM', value: 'członek komisji HM' },
                { label: 'przewodniczący komisji HM', value: 'przewodniczący komisji HM' },
                { label: 'członek Centralnej Szkoły Instruktorskiej', value: 'członek CSI' },
                { label: 'kierownik wydziału', value: 'kierownik wydziału' },
                { label: 'zastępca Naczelnika', value: 'zastępca Naczelnika' },
                { label: 'inna funkcja', value: 'inne' },
            ]
        },
        {
            label: 'Władze naczelne', value: 'władze naczelne', subitems: [
                { label: 'członek Rady Naczelnej', value: 'członek rady naczelnej' },
                { label: 'członek Komisji Rewizyjnej Związku', value: 'członek KRZ' },
                { label: 'przewodniczący Komisji Rewizyjnej Związku', value: 'przewodniczący KRZ' },
                { label: 'sędzia Sądu Harcerskiego', value: 'członek SH' },
                { label: 'prezes Sądu Harcerskiego', value: 'przewodniczący SH' },
                { label: 'pełnomocnik Naczelnictwa', value: 'pełnomocnik naczelnictwa' },
                { label: 'członek Naczelnictwa', value: 'członek naczelnictwa' },
                { label: 'Naczelniczka', value: 'naczelniczka' },
                { label: 'Naczelnik', value: 'naczelnik' },
                { label: 'inna funkcja', value: 'inne' },
            ]
        },
    ]

    public getTypes(): Promise<Option[]> {
        return new Promise((resolve, reject) => {
            const result = this.collection.map(item => {
                return {
                    label: item.label,
                    value: item.value,
                } as Option
            })
            resolve(result);
        });
    }

    public getSubTypes(valueType: string): Promise<Option[]> {
        return new Promise((resolve, reject) => {
            const item = this.collection.find(item => item.value == valueType);
            var result: Option[] = [];
            if (item != undefined) {
                result = item.subitems.map(item => {
                    return {
                        label: item.label,
                        value: item.value,
                    } as Option
                })
            }
            resolve(result);
        });
    }
}
